import { tryDeliverTo } from '../core/delivery';
import type { MachineEntity } from '../core/entities';
import type { SimEvent } from '../core/events';
import { peekPort, singleOutput, tryTakeFromPort } from '../core/port';
import { machinePorts } from '../core/routing';
import type { SimState } from '../core/state';
import { translate } from '../core/types';

/** Attempts to hand the machine's finished output packet to whatever sits downstream of it. */
export function drainOutput(state: SimState, machine: MachineEntity, events: SimEvent[]): void {
  const outputPort = singleOutput(machine.outputs);
  const finished = peekPort(outputPort);
  if (finished === undefined) return;

  const { outSide } = machinePorts(state, machine.position);
  const target = outSide ? translate(machine.position, outSide) : null;
  if (target && tryDeliverTo(state, target, finished, events, machine.position)) {
    tryTakeFromPort(outputPort);
  }
}
